<template>
  <div class="questionContainer">
    <div :class="
      this.currQuestion._cls === 'Programming'
        ? 'questionDetail programming-question'
        : 'questionDetail'
    ">
      <div v-if="showBanner" class="questionNumber">
        <div class="questionBanner">Question:</div>
        <div class="displayNumber">{{ currQuestion.number }}</div>
        <div class="marksBanner">
          <div class="marksCorrect">+{{ currQuestion.marks.correct }}</div>
          <div class="questionBorder"></div>
          <div class="marksIncorrect">-{{ currQuestion.marks.incorrect }}</div>
        </div>
      </div>

      <div class="questionView">
        <div class="questionDescription">
          <div v-if="this.currQuestion._cls !== 'Programming'" class="desc" :style="
            this.currQuestion._cls === 'Programming'
              ? 'width: fit-content'
              : ''
          " v-html="currQuestion.description"></div>
          <div v-if="this.currQuestion._cls === 'MCQ'" class="cls">
            <div v-for="(value, key) in this.currQuestion.options" :key="key" style="width: 100%">
              <OptionComponent :selected="value.value" :description="value.content" :option-key="key"
                :not-circle="currQuestion.multiple_answers" @selectionChanged="selectionChanged"></OptionComponent>
            </div>
          </div>
          <div v-if="this.currQuestion._cls === 'Programming'" id="programming" class="cls">
            <Programming id="programmingView" ref="programmingView" :curr-question="currQuestion" :total="total"
              @onMarkForReviewButtonPressed="
                $emit('onMarkForReviewButtonPressed')
              " @onNextButtonPressed="$emit('onNextButtonPressed')"></Programming>
            <ProgrammingResult id="editorView" ref="editorView" :curr-question="currQuestion"
              @onMarkForReviewButtonPressed="
                $emit('onMarkForReviewButtonPressed')
              " @onNextButtonPressed="PQNextButtonPressed" @changeDisplay="changeDisplay"
              @increaseTotalProgrammingSubmitted="
                increaseTotalProgrammingSubmitted
              "></ProgrammingResult>
          </div>
          <div v-else-if="this.currQuestion._cls === 'Subjective'" class="cls">
            <textarea v-model="currQuestion.answer" class="textArea" rows="7" cols="50"
              :placeholder="'Write your answer here'" onPaste="return false" @input="textAreaContentChanged"></textarea>
          </div>
        </div>
        <div class="warning-msg">
          <span v-if="!this.currQuestion.saved">Don't forget to submit the answer</span>
        </div>
        <div v-if="!(this.currQuestion._cls === 'Programming')" class="bottom-container">
          <div class="buttons">
            <div style="display: flex; flex-direction: row" class="btn-grp-responsive">
              <button :class="
                submitDisabled ? 'submitButtonDisabled' : 'submitButton'
              " :disabled="submitDisabled" @click="$emit('onSubmitButtonPressed')">
                SUBMIT
              </button>
              <button class="markForReviewButton button" @click="$emit('onMarkForReviewButtonPressed')">
                MARK FOR REVIEW
              </button>
            </div>

            <div style="display: flex; flex-direction: row">
              <button class="resetAnswerButton" @click="onResetAnswerPressed">
                RESET ANSWER
              </button>
              <button class="nextButton button" @click="$emit('onNextButtonPressed')">
                NEXT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OptionComponent from './Option'
import Programming from './Programming'
import ProgrammingResult from './ProgrammingResult'
import api from '../services/api.service'
import Split from 'split.js'

export default {
  name: 'QuestionDetail',
  components: { OptionComponent, Programming, ProgrammingResult },
  props: ['currQuestion', 'total'],
  data() {
    return {
      showBanner: true,
      splitInstance: undefined,
    }
  },
  computed: {
    submitDisabled() {
      var temp = false
      if (this.currQuestion.options) {
        for (var value of Object.values(this.currQuestion.options)) {
          console.log(value)
          temp = temp || value.value
        }
      }
      if (this.currQuestion.answer && this.currQuestion.answer.length > 0) {
        temp = temp | true
      }
      return !temp || this.currQuestion.saved
    },
  },
  methods: {
    selectionChanged: function (newValue) {
      if (newValue === this.currQuestion.lastSavedAnswer) {
        this.currQuestion.saved = true
      } else {
        this.currQuestion.saved = false
      }
      if (
        !this.currQuestion.multiple_answers &&
        !this.currQuestion.options[newValue].value
      ) {
        for (var value in this.currQuestion.options) {
          this.currQuestion.options[value].value = false
        }
      }
      this.currQuestion.options[newValue].value = true
    },
    textAreaContentChanged() {
      this.currQuestion.saved = false
    },
    onResetAnswerPressed: function () {
      this.currQuestion.saved = true
      this.currQuestion.lastSavedAnswer = ''
      const answer = {
        _id: this.currQuestion._id,
        _cls: this.currQuestion._cls,
      }
      api
        .deleteAnswer(
          this.$store.state.test.testId,
          this.$store.state.userId,
          answer
        )
        .then(() => {
          if (this.currQuestion._cls === 'MCQ') {
            for (var value in this.currQuestion.options) {
              this.currQuestion.options[value].value = false
            }
          } else {
            this.currQuestion.answer = ''
          }
          this.currQuestion.currentClass = 'normal'
        })

      this.$emit('decTotal')
    },
    PQNextButtonPressed: function () {
      this.$emit('onNextButtonPressed')
      document.getElementById('programming').style.display = 'block'
    },
    changeDisplay: function () {
      var doc = document.getElementById('programming')
      const programmingView = this.$refs.programmingView.$el
      const editorView = this.$refs.editorView.$el
      if (doc.style.display === 'flex') {
        document.getElementById('programming').style.display = 'block'
        programmingView.style.height = 'unset'
        editorView.style.height = 'unset'

        programmingView.style.overflowY = 'unset'
        editorView.style.overflowY = 'unset'
        this.splitInstance.destroy()
      } else {
        document.getElementById('programming').style.display = 'flex'
        document.getElementById('programming').style.flexDirection = 'row'
        programmingView.style.height = 'calc(100vh - 225px)'
        editorView.style.height = 'calc(100vh - 225px)'

        programmingView.style.overflowY = 'auto'
        editorView.style.overflowY = 'auto'
        this.splitInstance = Split(['#programmingView', '#editorView'])
      }
      this.$emit('hideSidePanes')
    },
    increaseTotalProgrammingSubmitted() {
      this.$emit('increaseTotalProgrammingSubmitted')
    },
  },
  mounted() {
    this.$nextTick(function () {
      // Use the below for MathJax version < 3
      // MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.body])

      // For MathJax version 3.0 and above use below
      MathJax.typeset();
    });
  },
  updated() {
    MathJax.typeset();
  },
}
</script>

<style scoped>
.submitButtonDisabled {
  background: #eeeeee;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  width: 126px;
  height: 40px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #9b9b9b;
}

.questionContainer {
  display: flex;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  margin-right: 2px;
}

.textArea {
  resize: vertical;
  width: 729px;
  padding: 10px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #343c4b;
  box-sizing: border-box;
  cursor: text;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  width: 729px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(155, 155, 155, 0.2);
}

.desc {
  margin-bottom: 8px;
  width: 100%;
  word-break: break-word;
}

.nextButton {
  outline: none;
  background: white;
  border: none;
  box-sizing: border-box;
  height: 40px;
  width: 104px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1bc09c;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 12px;
  color: #1bc09c;
}

.resetAnswerButton {
  outline: none;
  background: white;
  border: none;
  box-sizing: border-box;
  height: 40px;
  width: 104px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #1bc09c;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 12px;
  color: #1bc09c;
}

.markForReviewButton {
  outline: none;
  border: none;
  box-sizing: border-box;
  height: 40px;
  width: 143px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #616262;
}

.markForReviewButton:hover {
  background: #ffd600;
}

.submitButton {
  outline: none;
  border: none;
  box-sizing: border-box;
  width: 126px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0988f4;
  border-radius: 2px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #ffffff;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.buttons button {
  cursor: pointer;
}

.questionDetail {
  display: flex;
  flex-direction: column;
  margin: 0 32px;
  width: 100%;
  align-items: center;
}

.questionNumber {
  flex: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 42px;
  background: #ffffff;
  border-radius: 2px;
}

.questionBanner {
  align-self: flex-start;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #69758b;
  margin-left: 16px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.displayNumber {
  font-family: Roboto-Medium;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  margin-top: 12px;
  margin-left: 0.8px;
}

.marksBanner {
  display: flex;
  flex-direction: row;
  font-family: Roboto-Regular;
  font-size: 12px;
  margin-left: auto;
  margin-right: 16px;
}

.marksCorrect {
  margin-top: 12px;
  color: #1bc09c;
}

.marksIncorrect {
  margin-top: 12px;
  margin-left: 7.5px;
  color: #f66957;
}

.questionBorder {
  margin-top: 8.5px;
  margin-left: 8.5px;
  width: 1px;
  height: 22px;
  background: #e4e8eb;
}

.questionView {
  width: 100%;
  margin-top: 34px;
  background: #ffffff;
  border-radius: 2px;
}

.questionDescription {
  padding: 16px 24px 12px 24px;
  display: flex;
  flex-direction: column;
  font-family: Roboto-Regular;
  font-size: 18px;
  color: #343c4b;
  line-height: 24px;
}

.buttons button {
  cursor: pointer;
}

.button {
  margin-left: 25px;
}

.programming-question {
  margin-left: 16px;
  margin-right: 16px;
  width: -moz-available;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
}

.warning-msg {
  font-size: 12px;
  color: red;
  padding-left: 24px;
  height: 16px;
}

.bottom-container {
  padding: 10px 24px 37px 24px;
}

.btn-grp-responsive {
  margin-bottom: 10px;
}

@media only screen and (max-width: 1440px) {
  .questionDescription {
    font-size: 16px;
  }
}
</style>
